// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/fb-decode.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/fb-decode/fb-decode.js';

mount([g0]);
